import { ElementRef } from '@angular/core';

export function matchesSelectSearch(query: string, name?: string): boolean {
  const needle = (query || '').trim().toLowerCase();
  if (!needle) {
    return true;
  }
  return (name || '').toLowerCase().includes(needle);
}

export function focusSelectSearchInput(input?: ElementRef<HTMLInputElement>): void {
  requestAnimationFrame(() => input?.nativeElement?.focus());
}
